export default {
  showForeignReviews: state => state.general.showCountryAndForeignReviews,
  dashboardLanguage: state => state.general.dashboardLanguage,
};
